import { render, staticRenderFns } from "./peopleStream.vue?vue&type=template&id=503ac89a&"
import script from "./peopleStream.vue?vue&type=script&lang=js&"
export * from "./peopleStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports